/**
 * Application-wide constants (roles, config keys) to avoid magic strings.
 */
export const ROLES = {
    ADMIN: 'Admin',
    CLASS_ADMIN: 'Class Admin',
};

export const CONFIG_KEYS = {
    CM_TAB_REFRESH_TIME: 'CM_TAB_REFRESH_TIME',
};
